// Pure atlas-frame maths shared by the SVG face renderer and the 3D board layers. No React, no DOM.

export type Box = { x: number; y: number; w: number; h: number };

/** Face.tsx atlasImage maths: the viewBox selected from the frame for a box, and the preserveAspectRatio it is drawn with. */
export function atlasView(frame: Box, box: Box, fit: 'cover' | 'contain' | 'fill' | 'none' | undefined, focus: [number, number]): { view: Box; par: 'none' | 'xMidYMid meet' } {
  if (fit === 'contain') return { view: frame, par: 'xMidYMid meet' };
  if (fit === 'fill') return { view: frame, par: 'none' };
  const s = Math.max(box.w / frame.w, box.h / frame.h), vw = box.w / s, vh = box.h / s;
  const cx = (frame.w * focus[0]) / 100 - vw / 2, cy = (frame.h * focus[1]) / 100 - vh / 2;
  const clamp = (v: number, lo: number, hi: number) => Math.min(Math.max(v, lo), hi);
  return { view: { x: frame.x + clamp(cx, 0, frame.w - vw), y: frame.y + clamp(cy, 0, frame.h - vh), w: vw, h: vh }, par: 'none' };
}
